<template>
    <div>
        <div class="bottoms">
            <span class="mr-20 link"   @click="handleJump('/XAbout?tab=1')">协会简介</span>
            <span class="mr-20 link"  @click="handleJump('/XAbout?tab=2')">协会章程</span>
            <span class="mr-20 link"   @click="handleJump('/XAbout?tab=3')">会长理事名单</span>
            <span class="mr-20 link"   @click="handleJump('/XAbout?tab=4')">组织机构</span>
            <span  class=" link" @click="handleJump('/XAbout?tab=5')"> 联系我们</span>
            <div class="text">
                <div>上海市工程咨询行业协会@2018 All Rights Reserved</div>
                <div>保留版权所有 沪ICP备15013469号</div>
            </div>
        </div>
    </div>
</template>

<script> 
  export default {
    data(){
      return{

      }    
    },
    methods: {   
    handleJump(path){
        this.$router.push({
            path: path,
      
        }, () => {})
      },  
    }
  }
</script>
<style lang="scss" scoped>
  @import './XFooter.scss';

</style>